var exports = {
  "kL": "x804f0401--da1b30--container",
  "Pf": "x804f0401--da1b30--label",
  "M0": "x804f0401--da1b30--bar",
  "O0": "x804f0401--da1b30--rating",
};

module.exports = exports;
